import API from "../../../services/api";

const BASE = "/tools/ctc-planner";

export async function fetchCtcPlannerPresets() {
  const { data } = await API.get(`${BASE}/presets`);
  return data;
}

export async function calculateCtcStructure(body) {
  const { data } = await API.post(`${BASE}/calculate`, body);
  return data;
}
